import { LoadingStatus } from "src/libs/fetcher";
import { useCardThemed } from "./useCardThemed";
import { type CardThemeIdentifier } from "./card-theme-utils";

export type ThemeSeparatorProps = {
  themeId?: CardThemeIdentifier;
};

export function ThemeSeparator({ themeId }: ThemeSeparatorProps) {
  const { theme, status } = useCardThemed(themeId);

  if (status !== LoadingStatus.SUCCESS) {
    return null;
  }

  return (
    <div
      className="mx-auto h-0 w-1/4 border-t"
      style={{
        borderColor: theme.separatorColor || "transparent",
      }}
    />
  );
}
